import { EditIcon, Paragraph } from '@quickmd-llc/design-system';
import { BodyMeasurementQuestion, Question } from '@qmd-types/intakeForms';
import { useIntakeForm } from '../../context/useIntakeForm';

type Props = {
  onEdit: (question: Question) => void;
  question: BodyMeasurementQuestion;
};

export function BodyMeasurementReviewSection({ onEdit, question }: Props) {
  const { isIntakeFormComplete } = useIntakeForm();
  const { heightInches, weightPounds } = question;
  const heightFeet = heightInches ? Math.floor(heightInches / 12) : 0;
  const remainingInches = heightInches ? heightInches % 12 : 0;
  const weight = weightPounds || 0;

  return (
    <div className="grid gap-6">
      <div className="grid gap-0.5">
        <div className="flex items-start justify-between gap-4">
          <Paragraph className="font-semibold">How tall are you?</Paragraph>
          {!isIntakeFormComplete && (
            <EditIcon
              className="cursor-pointer"
              onClick={() => onEdit(question)}
              size="lg"
            />
          )}
        </div>

        <Paragraph className="text-shade-80">
          {heightFeet}'{remainingInches}
        </Paragraph>
      </div>

      <div className="grid gap-0.5">
        <Paragraph className="font-semibold">
          What is your current weight?
        </Paragraph>

        <Paragraph className="text-shade-80">{weight}lbs</Paragraph>
      </div>
    </div>
  );
}
